import { useState, useEffect } from "react";
import {
  Grid,
  Card,
  Button,
  Dialog,
  DialogActions,
  DialogContent
} from "@mui/material/";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { style } from "style";
import moment from 'moment';
import CustomExport from "components/CustomExport";
import { QueryAPI } from "API/QueryAPI";
import { checkResponse } from "helpers/notification";
import { useNavigate, useLocation } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux";
import { FirmReportAPI } from "API/FirmReportAPI";
import {
  setUserEuIdData
} from "features/firmReportSlice";

function Queries() {
  // consts
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [list, setList] = useState([]);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedRequestParamters, setSelectedRequestParamters] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const userEuIdData = useSelector(state => state.firmReport.userEuIdData);
  const [queryIdFromUrl, setQueryIdFromUrl] = useState("");

  const [fullListDialogOpen, setFullListDialogOpen] = useState(false);
  const [fullListNumbers, setFullListNumbers] = useState([]);

  const [dictionaryKeys, setDictionaryKeys] = useState([]);
  const [columnsExport, setColumnsExport] = useState([]);
  const [rowsExport, setRowsExport] = useState([]);

  var groupId = useSelector(state => state.common.groupId);
  var userName = useSelector(state => state.common.userName);

  const renderPhoneSearchValue = (queryType, key, value) => {
    if (
      queryType === "phonesearch" &&
      (key === "numara" || key === "kullanici_adi")
    ) {
      let numbers = [];

      if (Array.isArray(value)) {
        numbers = value;
      } else if (typeof value === "string") {
        numbers = value.includes(",") ? value.split(",") : [value];
      }

      if (numbers.length > 10) {
        const firstTen = numbers.slice(0, 10);

        return (
          <div>
            {firstTen.map((v, idx) => (
              <div key={idx}>{v.trim()}</div>
            ))}

            <MDTypography
              sx={{ cursor: "pointer", color: "#1976d2", fontSize: "12px", marginTop: "4px" }}
              onClick={() => {
                setFullListNumbers(numbers);
                setFullListDialogOpen(true);
              }}
            >
              ...Sorgu sırasında kullanılan numaraların tamamını görmek için tıklayınız
            </MDTypography>
          </div>
        );
      }

      return numbers.map((v, idx) => <div key={idx}>{v.trim()}</div>);
    }

    return value;
  };

  const getParameterNamesMapping = (queryType) => {
    switch (queryType) {
      case "sendingreport":
        return {
          baslangic_tarihi: "Başlangıç Tarihi",
          bitis_tarihi: "Bitiş Tarihi",
          mesaj_basligi: "Mesaj Başlığı",
          mesaj_konusu: "Mesaj Konusu",
        };
      case "sendingreportdetailfile":
        return {
          baslangic_tarihi: "Başlangıç Tarihi",
          bitis_tarihi: "Bitiş Tarihi",
          rapor_dosya_adi: "Dosya Adı",
          mesaj_basligi: "Mesaj Başlığı"
        };
      case "sendingreportdetailsumfile":
        return {
          baslangic_tarihi: "Başlangıç Tarihi",
          bitis_tarihi: "Bitiş Tarihi",
          rapor_dosya_adi: "Dosya Adı",
          mesaj_basligi: "Mesaj Başlığı",
          mesaj_konusu: "Gönderim Adı"
        };
      case "phonesearch":
        return {
          baslangic_tarihi: "Başlangıç Tarihi",
          bitis_tarihi: "Bitiş Tarihi",
          numara: "Numara",
          kullanici_adi: "Kullanıcı Adı"
        };
      case "alphanumericreport":
        return {
          mesaj_basligi: "Mesaj Başlığı",
          baslangic_tarihi: "Başlangıç Tarihi",
          bitis_tarihi: "Bitiş Tarihi",
        };
      case "firmreport":
        return {
          baslangic_tarihi: "Başlangıç Tarihi",
          bitis_tarihi: "Bitiş Tarihi",
          gonderim_yapilan_servisler: "Gönderim Yapılan Servisler",
          firma_adi: "Firma Adı",
        };
      case "dailyreport":
        return {
          baslangic_tarihi: "Başlangıç Tarihi",
          bitis_tarihi: "Bitiş Tarihi",
        };
      case "firmreportbulkdetail":
        return {
          baslangic_tarihi: "Başlangıç Tarihi",
          bitis_tarihi: "Bitiş Tarihi",
          mesaj_basligi: "Mesaj Başlığı",
        };
      case "firmreportfastotpdetail":
        return {
          baslangic_tarihi: "Başlangıç Tarihi",
          bitis_tarihi: "Bitiş Tarihi",
          mesaj_basligi: "Mesaj Başlığı",
          kullanici_adi: "Kullanıcı Adı",
          sanal_numara: "Sanal Numara",
          gönderim_tipi: "Gönderim Tipi"
        };
      default:
        return {
          baslangic_tarihi: "Başlangıç Tarihi",
          bitis_tarihi: "Bitiş Tarihi",
          rapor_dosya_adi: "Dosya Adı",
          numara: "Numara"

        };
    }
  };

  const getLoginNames = async () => {
    const getUserGroupRelatedLoginNameResponse = await FirmReportAPI.GetUserGroupRelatedLoginName(groupId);
    dispatch(setUserEuIdData(getUserGroupRelatedLoginNameResponse.data.resultObject));
  };

  const handleNavigate = (type, id, requestParameters, e) => {

    const data = {
      queryId: id,
      requestParameters: requestParameters,
      type: type
    };
    switch (type) {
      case "sendingreport":
      case "firmreportbulkdetail":
        navigate('/GonderimRaporuDetay', { state: data });
        break;
      case "phonesearch":
        navigate('/NumaraSorgulamaDetay', { state: data });
        break;
      case "firmreport":
        navigate('/FirmaRaporuDetay', { state: data });
        break;
      case "alphanumericreport":
        navigate('/AlfanumerikRaporuDetay', { state: data });
        break;
      case "dailyreport":
        navigate('/GunlukRaporDetay', { state: data });
        break;
      case "firmreportfastotpdetail":
        navigate('/FastDetayRaporu', { state: data });
        break;
      default:
        navigate('/GonderimRaporu');
        break;
    }
  };

  useEffect(() => {
    const createRowsAndColoumns = async e => {
      const rowsData = [];
      const queryId = location.state?.queryId;
      if (list.length > 0) {

        setDictionaryKeys(Object.keys(list[0].normalizedParameters || {}));

        const filteredList = list
          .filter(data => data.parentId === "BsonNull" && (!queryId || data.idStr === queryId))
          .sort((a, b) => new Date(b.insertDate) - new Date(a.insertDate));
        filteredList.map(data => {

          let typeStr = "";
          switch (data.type) {
            case "sendingreport": typeStr = "Gönderim Raporu Talebi"; break;
            case "phonesearch": typeStr = "Numara Sorgulama Raporu Talebi"; break;
            case "alphanumericreport": typeStr = "Alfanümerik Raporu Talebi"; break;
            case "firmreport": typeStr = "Firma Raporu Talebi"; break;
            case "dailyreport": typeStr = "Günlük Rapor Talebi"; break;

          }

          const idStr = data.parentId && data.parentId !== "BsonNull" ? (
            <span>
              <strong>{data.parentId}</strong> ID'sine Ait {typeStr}
            </span>
          ) : (
            typeStr
          );

          rowsData.push({
            id: data.idStr,
            userName: data.userName,
            status: data.status,
            type: data.type,
            typeStr: idStr,
            typeUserFriendly: data.typeUserFriendly,
            name: data.name,
            date: moment(data.insertDate).format('DD/MM/YYYY HH:mm'),
            requestParametersJson: data.requestParametersJson,
            requestParametersUserFriendlyJson: data.requestParametersUserFriendlyJson,
            requestParametersUserFriendlyText: data.requestParametersUserFriendlyText,
            statusStr: data.statusStr,
            normalizedParameters: data.normalizedParameters,
          })
        });
      }
      setRows(rowsData);

      setColumns([
        {
          headerName: "id", field: "id", flex: 1,
          renderCell: params => {
            return (
              <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                {params.row.id}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Kullanıcı Adı", field: "userName", flex: 1,
          renderCell: params => {
            return (
              <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                {params.row.userName}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Sorgu Durumu",
          field: "statusStr",
          flex: 1,
          hide: true
        },
        {
          headerName: "Sorgu Durumu", field: "status", flex: 1, disableExport: true,
          renderCell: params => {
            return (
              <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                {
                  params.row.status == "0" ?
                    params.row.type.includes("file") ?
                      <span style={{ color: "orange" }}>🟡 Dosya Talebi Alındı</span> :
                      <span style={{ color: "orange" }}>🟡 Sorgu Talebi Alındı</span> :
                    params.row.status == "1" ?
                      params.row.type.includes("file") ?
                        <span style={{ color: "#1976d2" }}>🔄 Dosya Hazırlanıyor</span> :
                        <span style={{ color: "#1976d2" }}>🔄 Sorgu Hazırlanıyor</span> :
                      params.row.status == "2" ?
                        params.row.type.includes("file") ?
                          <span style={{ color: "green" }}>✅ Dosya Hazır</span> :
                          <span style={{ color: "green" }}>✅ Sorgu Hazır</span> :
                        params.row.status == "3" ?
                          params.row.type.includes("file") ?
                            <span style={{ color: "red" }}>❌ Dosya Hazırlanırken Hata Alındı</span> :
                            <span style={{ color: "red" }}>❌ Sorgu Hazırlanırken Hata Alındı</span> :

                          <span style={{ color: "red" }}>⛔ Sorgu İptal Edildi</span>
                }
              </MDTypography>
            );
          }
        },
        {
          headerName: "Sorgu Tipi", field: "type", flex: 1, disableExport: true,
          renderCell: params => {
            return (
              <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                {params.row.typeStr}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Sorgu Tipi", field: "typeUserFriendly", flex: 1, hide: true,
          renderCell: params => {
            return (
              <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                {params.row.typeUserFriendly}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Sorgu Adı", field: "name", flex: 0.5,
          renderCell: params => {
            return (
              <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                {params.row.name}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Sorgu Oluşma Tarihi",
          field: "date",
          flex: 1,
          renderCell: params => {
            return (
              <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                {params.row.date}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Sorgu Parametreleri",
          field: "requestParametersJson",
          flex: 1,
          disableExport: true,
          renderCell: params => {
            return ({
              headerName: "Sorgu Parametreleri",
              field: "requestParametersJson",
              flex: 1,
              renderCell: params => {
                return (
                  <MDTypography
                    sx={style.interactiveLinkButton}
                    onClick={e => {
                      setDialogOpen(true);
                      setSelectedRequestParamters({ ...JSON.parse(params.row.requestParametersUserFriendlyJson), type: params.row.type });
                    }}

                  >
                    Parametreler için Tıklayın..
                  </MDTypography>
                );
              }
            },
              <MDTypography
                sx={style.interactiveLinkButton}
                onClick={e => {
                  setDialogOpen(true);
                  setSelectedRequestParamters({ ...JSON.parse(params.row.requestParametersUserFriendlyJson), type: params.row.type });
                }}

              >
                Parametreler için Tıklayın..
              </MDTypography>
            );
          }
        },
        {
          headerName: "Detay", field: "action", flex: 1, disableExport: true,
          renderCell: params => {
            return (
              params.row.status == "0" ?

                params.row.type.includes("file") ?
                  <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                    Dosya Talebi Alındı
                  </MDTypography>
                  :
                  <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                    Detay Talebi Alındı
                  </MDTypography>

                :
                params.row.status == "1" ?

                  params.row.type.includes("file") ?
                    <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                      Dosya İndir Hazırlanıyor
                    </MDTypography>
                    :
                    <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                      Detay Görüntüle Hazırlanıyor
                    </MDTypography>

                  :
                  params.row.status == "2" ?
                    params.row.type.includes("file") ?
                      <MDTypography
                        sx={style.interactiveLinkButton}
                        onClick={() => handleNavigate(params.row.type, params.row.id, params.row.requestParametersJson)}  // burada sorgu tipine göre bir gönderim yapılacak  handleNavigate(params.row.type, params.row.id)
                      >
                        Dosya İndir
                      </MDTypography>
                      :
                      <MDTypography
                        sx={style.interactiveLinkButton}
                        onClick={() => handleNavigate(params.row.type, params.row.id, params.row.requestParametersJson)}  // burada sorgu tipine göre bir gönderim yapılacak  handleNavigate(params.row.type, params.row.id)
                      >
                        Detay Görüntüle
                      </MDTypography>

                    :
                    params.row.status == "3" ?

                      params.row.type.includes("file") ?
                        <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                          Dosya Hazırlanırken Hata Alındı
                        </MDTypography>
                        :
                        <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                          Sorgu Hazırlanırken Hata Alındı
                        </MDTypography>

                      :
                      <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                        Sorgu İptal edildi
                      </MDTypography>
            );
          },
        },
      ]);

    };

    createRowsAndColoumns();
  }, [list]);

  useEffect(() => {
    if (dictionaryKeys.length > 0 && rows.length > 0) {

      setColumnsExport([
        {
          headerName: "id", field: "id", flex: 1,
          renderCell: params => {
            return (
              <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                {params.row.id}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Kullanıcı Adı", field: "userName", flex: 1,
          renderCell: params => {
            return (
              <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                {params.row.userName}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Sorgu Durumu",
          field: "statusStr",
          flex: 1,
          hide: true
        },
        {
          headerName: "Sorgu Durumu", field: "status", flex: 1, disableExport: true,
          renderCell: params => {
            return (
              <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                {
                  params.row.status == "0" ?
                    params.row.type.includes("file") ?
                      <span style={{ color: "orange" }}>🟡 Dosya Talebi Alındı</span> :
                      <span style={{ color: "orange" }}>🟡 Sorgu Talebi Alındı</span> :
                    params.row.status == "1" ?
                      params.row.type.includes("file") ?
                        <span style={{ color: "#1976d2" }}>🔄 Dosya Hazırlanıyor</span> :
                        <span style={{ color: "#1976d2" }}>🔄 Sorgu Hazırlanıyor</span> :
                      params.row.status == "2" ?
                        params.row.type.includes("file") ?
                          <span style={{ color: "green" }}>✅ Dosya Hazır</span> :
                          <span style={{ color: "green" }}>✅ Sorgu Hazır</span> :
                        params.row.status == "3" ?
                          params.row.type.includes("file") ?
                            <span style={{ color: "red" }}>❌ Dosya Hazırlanırken Hata Alındı</span> :
                            <span style={{ color: "red" }}>❌ Sorgu Hazırlanırken Hata Alındı</span> :

                          <span style={{ color: "red" }}>⛔ Sorgu İptal Edildi</span>
                }
              </MDTypography>
            );
          }
        },
        {
          headerName: "Sorgu Tipi", field: "type", flex: 1, disableExport: true,
          renderCell: params => {
            return (
              <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                {params.row.typeStr}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Sorgu Tipi", field: "typeUserFriendly", flex: 1, hide: true,
          renderCell: params => {
            return (
              <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                {params.row.typeUserFriendly}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Sorgu Adı", field: "name", flex: 0.5,
          renderCell: params => {
            return (
              <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                {params.row.name}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Sorgu Oluşma Tarihi",
          field: "date",
          flex: 1,
          renderCell: params => {
            return (
              <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                {params.row.date}
              </MDTypography>
            );
          }
        },
        {
          headerName: "Sorgu Parametreleri",
          field: "requestParametersJson",
          flex: 1,
          disableExport: true,
          renderCell: params => {
            return ({
              headerName: "Sorgu Parametreleri",
              field: "requestParametersJson",
              flex: 1,

              renderCell: params => {
                return (
                  <MDTypography
                    sx={style.interactiveLinkButton}
                    onClick={e => {
                      setDialogOpen(true);
                      setSelectedRequestParamters({ ...JSON.parse(params.row.requestParametersUserFriendlyJson), type: params.row.type });
                    }}

                  >
                    Parametreler için Tıklayın..
                  </MDTypography>
                );
              }
            },
              <MDTypography
                sx={style.interactiveLinkButton}
                onClick={e => {
                  setDialogOpen(true);
                  setSelectedRequestParamters({ ...JSON.parse(params.row.requestParametersUserFriendlyJson), type: params.row.type });
                }}

              >
                Parametreler için Tıklayın..
              </MDTypography>
            );
          }
        },
        {
          headerName: "Detay", field: "action", flex: 1, disableExport: true,
          renderCell: params => {
            return (
              params.row.status == "0" ?

                params.row.type.includes("file") ?
                  <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                    Dosya Talebi Alındı
                  </MDTypography>
                  :
                  <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                    Detay Talebi Alındı
                  </MDTypography>

                :
                params.row.status == "1" ?

                  params.row.type.includes("file") ?
                    <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                      Dosya İndir Hazırlanıyor
                    </MDTypography>
                    :
                    <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                      Detay Görüntüle Hazırlanıyor
                    </MDTypography>

                  :
                  params.row.status == "2" ?
                    params.row.type.includes("file") ?
                      <MDTypography
                        sx={style.interactiveLinkButton}
                        onClick={() => handleNavigate(params.row.type, params.row.id, params.row.requestParametersJson)}  // burada sorgu tipine göre bir gönderim yapılacak  handleNavigate(params.row.type, params.row.id)
                      >
                        Dosya İndir
                      </MDTypography>
                      :
                      <MDTypography
                        sx={style.interactiveLinkButton}
                        onClick={() => handleNavigate(params.row.type, params.row.id, params.row.requestParametersJson)}  // burada sorgu tipine göre bir gönderim yapılacak  handleNavigate(params.row.type, params.row.id)
                      >
                        Detay Görüntüle
                      </MDTypography>

                    :
                    params.row.status == "3" ?

                      params.row.type.includes("file") ?
                        <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                          Dosya Hazırlanırken Hata Alındı
                        </MDTypography>
                        :
                        <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                          Sorgu Hazırlanırken Hata Alındı
                        </MDTypography>

                      :
                      <MDTypography color='text' fontWeight='regular' fontSize='12px'>
                        Sorgu İptal edildi
                      </MDTypography>
            );
          },
        },
        ...dictionaryKeys.map((key) => ({
          headerName: key.replaceAll("_", " ").replace(/\b\w/g, char => char.toUpperCase()),
          field: key,
          flex: 1,
          hide: true
        }))
      ]);

      let rowsData = [];
      rows.map(data => {

        const dynamicColumnsData = dictionaryKeys.reduce((acc, key) => {
          acc[key] = data.normalizedParameters?.[key] ?? "";
          return acc;
        }, {});

        rowsData.push({
          id: data.id,
          userName: data.userName,
          status: data.status,
          type: data.type,
          typeStr: data.typeStr,
          typeUserFriendly: data.typeUserFriendly,
          name: data.name,
          date: moment(data.insertDate).format('DD/MM/YYYY HH:mm'),
          requestParametersJson: data.requestParametersJson,
          requestParametersUserFriendlyJson: data.requestParametersUserFriendlyJson,
          requestParametersUserFriendlyText: data.requestParametersUserFriendlyText,
          statusStr: data.statusStr,
          normalizedParameters: data.normalizedParameters,
          ...dynamicColumnsData
        })

      });

      setRowsExport(rowsData);

    }
  }, [dictionaryKeys]);

  const getQueries = async e => {

    const getQueriesResponse = await QueryAPI.GetQueries(userName);
    if (
      checkResponse(
        getQueriesResponse,
        null,
        "Sorguları getirme işlemi başarısız oldu.Lütfen Tekrar deneyin."
      )
    ) {
      if (getQueriesResponse.data.resultObject.length > 0) {
        setList(getQueriesResponse.data.resultObject);
      }
    }
  }

  useEffect(() => {
    getQueries();

    if (userEuIdData.length == 0) {
      getLoginNames();
    }
    const queryId = location.state?.queryId;

    setQueryIdFromUrl(queryId);
  }, []);

  const getStatusBadge = (status) => {
    if (status === "Sorgu Hazır")
      return <span style={{ color: "green" }}>✅ Sorgu Hazır</span>;

    if (status === "Sorgu Bekliyor")
      return <span style={{ color: "orange" }}>🟡 Sorgu Bekliyor</span>;

    if (status === "Sorgu Başarısız")
      return <span style={{ color: "red" }}>❌ Sorgu Başarısız</span>;

    return status; // eşleşmezse normal yaz
  };
  useEffect(() => {
    const onRefresh = async () => {
      await getQueries();
    };

    window.addEventListener("pageRefreshRequested", onRefresh);
    return () => window.removeEventListener("pageRefreshRequested", onRefresh);
  }, [userName]);


  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={3} pb={1}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant='gradient'
                bgColor='info'
                borderRadius='lg'
                coloredShadow='info'
              >
                <MDTypography variant='h6' color='white'>
                  Sorgular
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <CustomExport
                  rows={rows}
                  columns={columns}
                  exportFileName={userName
                    + "_RaporDosyaIndirmeListesi_"
                    + moment(new Date()).format('YYYYMMDDHHmmss').toString()}
                  queryIdFromUrl={queryIdFromUrl}
                  columnsExport={columnsExport}
                  rowsExport={rowsExport}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Dialog open={dialogOpen} fullWidth={true} maxWidth='md'>
        <DialogContent>
          <MDBox pt={3} pb={1}>
            {Object.entries(selectedRequestParamters)
              .filter(([key, value]) => value && !['type', 'groupId', 'rightFormat', 'returnValue', 'reportType', 'custEuIdList', 'jobEuId', 'fromMongoDb', 'userEuId', 'acntEuId'].includes(key))
              .map(([key, value]) => {
                const queryType = selectedRequestParamters.type;
                const parameterNamesMapping = getParameterNamesMapping(queryType);
                return (
                  <Grid key={key} container spacing={0}>
                    <Grid item xs={4} md={4} lg={4} style={style.gridLabelStyle}>
                      <span style={{ fontSize: "small", fontWeight: "bold" }}>
                        {parameterNamesMapping[key] || key}
                      </span>
                    </Grid>
                    <Grid item xs={8} md={8} lg={8}>
                      {renderPhoneSearchValue(queryType, key, value)}

                    </Grid>
                  </Grid>
                );
              })}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={e => setDialogOpen(false)}
            color='primary'
            autoFocus
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={fullListDialogOpen} fullWidth maxWidth="sm">
        <DialogContent style={{ maxHeight: "60vh", overflowY: "auto" }}>
          {fullListNumbers.map((v, idx) => (
            <div key={idx} style={{ fontSize: "14px", padding: "4px 0" }}>
              {v}
            </div>
          ))}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setFullListDialogOpen(false)} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>




    </DashboardLayout>
  );
}

export default Queries;
